import React, { Component } from "react"
import { connect } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import { withRouter } from "react-router-dom"

import PropTypes from "prop-types"
import classNames from "classnames"
import Button from "@material-ui/core/Button"
import Avatar from "@material-ui/core/Avatar"
import Grid from "@material-ui/core/Grid"
import Icon from "@material-ui/core/Icon"
import IconButton from "@material-ui/core/IconButton"
import Typography from "@material-ui/core/Typography"

import AstrologerProfileWallet from "../../astrologer/profile/components/wallet"
import {
  getUploadImge,
  createUrl,
  timeAgo,
  _toFixed,
} from "../../../utils/functions"

class UserListCard extends Component {
  state = {
    showProfile: false,
  }

  showProfile = () => {
    let { id, history } = this.props
    this.setState({ showProfile: true })
  }

  render() {
    const {
      classes,
      theme,
      row,
      professions,
      languages,
      id,
      isFavorite,
      dispatch,
      rightGridExtra,
    } = this.props
    let { showProfile } = this.state
    row.user_id = row.id
    return (
      <React.Fragment>
        <Grid container justify="center" className={classes.mainGrid}>
          <Grid item xs={3} className={classes.leftGrid}>
            <Avatar
              src={getUploadImge(row.image, "user/avatar")}
              classes={{ img: classes.avatarImg }}
              className={classes.avatar}
              onClick={this.showProfile}
            />
          </Grid>
          <Grid item xs={9} className={classes.rightGrid}>
            <div className={classes.content}>
              <Typography className={classes.name} onClick={this.showProfile}>
                {`${row.first_name} ${row.last_name} - #${row.id}`}
              </Typography>
              <Typography
                className={classes.name}
                style={{ color: "blue" }}
                onClick={this.showProfile}
              >
                {`${row.phone}`}
              </Typography>
              <Typography
                className={classes.name}
                style={{ color: "red" }}
                onClick={this.showProfile}
              >
                {`${_toFixed(row.wallet)} INR`}
              </Typography>
              <Typography
                className={classes.city}
                color="textSecondary"
                gutterBottom
              >
                <Icon
                  style={{ fontSize: 12, marginRight: 5, color: "#777171" }}
                >
                  location_on
                </Icon>
                {`+${row.country_code} ${row.phone}`}
              </Typography>
              <Typography>{row.email}</Typography>
              <Typography>
                Created On :{" "}
                {row.created_on
                  ? timeAgo(new Date(row.created_on * 1000))
                  : "-NA-"}
              </Typography>
              <Typography>
                Last Seen :{" "}
                {row.last_login
                  ? timeAgo(new Date(row.last_login * 1000))
                  : "-NA-"}
              </Typography>
            </div>
          </Grid>
        </Grid>
        {showProfile && (
          <React.Fragment>
            <br />
            <AstrologerProfileWallet row={row} />
          </React.Fragment>
        )}
        {rightGridExtra && rightGridExtra()}
      </React.Fragment>
    )
  }
}

const styles = (theme) => ({
  mainGrid: {
    minHeight: 130,
  },
  leftGrid: {
    alignSelf: "center",
    textAlign: "center",
  },
  rightGrid: {
    alignSelf: "flex-start",
  },
  details: {
    display: "flex",
    flexDirection: "column",
  },
  content: {
    flex: "1 0 auto",
    paddingTop: 20,
  },
  controls: {
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
  },
  avatar: {
    margin: "0 auto",
    marginBottom: 4,
    marginTop: 4,
    width: 60,
    height: 60,
  },
  avatarImg: {
    //width : 200
  },
  button: {
    margin: theme.spacing.unit,
    width: "90%",
    borderRadius: 0,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  city: {
    fontSize: 13,
    color: "#000",
  },
  name: {
    color: "#31708f",
    fontSize: 15,
  },
  profession: {
    marginRight: 10,
    color: "#0000008a",
    fontSize: 12,
  },
  language: {
    marginRight: 10,
    color: "#274e61",
    fontSize: 13,
  },
  actions: {
    textAlign: "center",
    margin: 0,
  },
  rating: {
    backgroundColor: "#37be5f",
    color: "#f7f7f7",
    fontSize: 12,
    display: "inline-block",
    margin: 0,
    padding: "3px 7px",
  },
  ratingCount: {
    color: "#999",
    fontSize: 11,
    textAlign: "center",
  },
  ratingStar: {
    fontSize: 14,
    marginLeft: 2,
  },
  ratingNew: {
    color: "#f52020",
    fontSize: 11,
    textAlign: "center",
    padding: 2,
    margin: "0 auto",
    border: "1px solid #ccc",
    marginTop: 2,
    background: "#dcb6b6",
    width: 60,
  },
  favButton: {
    float: "right",
    display: "inline-block",
  },
})

const mapStateToProps = ({ astrologers, enums }, { row }) => {
  row.isNew = row.new
  return {
    row,
    languages: enums.rows.languages.vt,
    professions: enums.rows.professions.vt,
  }
}
export default withRouter(
  connect(mapStateToProps)(withStyles(styles)(UserListCard))
)
